"use client";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Text, useMultiStyleConfig } from "@chakra-ui/react";
import { DropdownMenu, DropdownMenuButton, DropdownMenuList, } from "../../atoms";
const ToolbarButton = ({ action }) => {
    const { label, items, disabled } = action;
    const styles = useMultiStyleConfig("BulkAction");
    return (_jsxs(DropdownMenu, Object.assign({ placement: "top-end" }, { children: [_jsx(DropdownMenuButton, { title: label, dropDownIconVisible: !!items, onClick: () => { var _a; return !items && ((_a = action.onClick) === null || _a === void 0 ? void 0 : _a.call(action)); }, disabled: disabled, sx: styles.actionButton, type: "button" }), items && (_jsx(DropdownMenuList, Object.assign({ sx: {
                    boxShadow: "large !important",
                    overflowY: "auto",
                    overflowX: "hidden",
                    maxHeight: "290px",
                } }, { children: items })))] })));
};
const BulkAction = ({ actions, selectionLabel = "", visible = true }) => {
    const styles = useMultiStyleConfig("BulkAction");
    if (!visible) {
        return null;
    }
    return (_jsxs(Box, Object.assign({ sx: styles.container, boxShadow: "medium" }, { children: [_jsx(Box, { sx: styles.triangle }), _jsx(Box, Object.assign({ sx: styles.actionSelectionText }, { children: _jsx(Text, Object.assign({ variant: "subtitle.section", sx: styles.actionSelectionText }, { children: selectionLabel })) })), actions.map((action) => (_jsx(ToolbarButton, { action: action }, action.key)))] })));
};
export default BulkAction;
//# sourceMappingURL=BulkAction.js.map